import { formatAudioTime } from "../../utils/format-audio-time";

type AudioPlayerRemainingTimeProps = {
  durationSeconds: number;
  remainingSeconds: number;
};

/**
 * The countdown shares a grid cell with an invisible copy of the full
 * duration. Counting down can only shorten the string, so the duration
 * is the widest it will ever be; reserving that width stops the
 * flexible progress bar from resizing when the minutes drop a digit.
 * Values are right-aligned so the seconds hold still as they tick.
 */
function AudioPlayerRemainingTime({
  durationSeconds,
  remainingSeconds,
}: AudioPlayerRemainingTimeProps) {
  return (
    <span className="grid shrink-0 justify-items-end font-jakarta font-medium text-sm tabular-nums leading-6">
      <span className="invisible col-start-1 row-start-1 whitespace-nowrap">
        {formatAudioTime(durationSeconds)}
      </span>
      <span className="col-start-1 row-start-1 whitespace-nowrap">
        {formatAudioTime(remainingSeconds)}
        <span className="sr-only"> remaining</span>
      </span>
    </span>
  );
}

export { AudioPlayerRemainingTime };
